import { message } from "antd";
import * as React from "react";
import { IoArrowDownCircleOutline } from "react-icons/io5";

import { IAdvisorPackageCardBlock } from "@types";

import { AdvisorButton } from "./AdvisorButton";
import { readPackageValues, useApplyAdvisorPackage } from "./applyPackage";
import { Loader } from "./Loader";

/** Carries the package above it into the offer modeller's fields, which are then saved as usual. */
export function ApplyPackageButton({
  block,
  onApplied,
}: {
  block: IAdvisorPackageCardBlock;
  onApplied: () => void;
}) {
  const applyAdvisorPackage = useApplyAdvisorPackage();
  const [applying, setApplying] = React.useState(false);
  const values = readPackageValues(block);
  if (!values) return null;

  const handleClick = async () => {
    setApplying(true);
    try {
      await applyAdvisorPackage(values);
      message.success("Recommended offer applied to the offer modeller.");
      onApplied();
    } finally {
      setApplying(false);
    }
  };

  return (
    <div className="mt-4">
      <AdvisorButton
        variant="primary"
        onClick={handleClick}
        disabled={applying}
      >
        {applying ? (
          <Loader variant="circular" size="sm" />
        ) : (
          <IoArrowDownCircleOutline className="h-4 w-4" />
        )}
        {applying ? "Applying…" : "Use this offer"}
      </AdvisorButton>
    </div>
  );
}
